<!-- Loader-->
<div class="div-window_maps_title" *ngIf="!isLoaded">
  <div class="h3 loaderH3">My Maps</div>
  <div id="loadingText" class="h5">Loading...</div>
</div>
<!-- If login setting change -->
<div *ngIf="updateSetting" class="alert alert-success" id="redirect_setting_msg" role="alert"
  style="margin-left: 23%; padding: 1%; display: none; display: block">
  Login redirection setting saved!
</div>

<!-- Maps and Shared Maps -->
<div class="container">
  <!-- My maps-->
  <div class="div-window_maps" id="testing_my_maps"
    *ngIf="subscriptionsArray?.length && isLoaded && activeMapAvailable">
    <div class="h3 myMaps">
      My Maps
      <button type="button " class="text-btn" *ngIf="!isEdit" (click)="editSubscription()">
        Edit subscriptions
      </button>
    </div>
    <div *ngFor="let sub of subscriptionsArray">
      <div *ngIf="sub.status !== 'expired'">
        <div class="sub_name">
          <a [ngStyle]="{'background-color': sub.map_type_color}" class="btn pv-map-cls subscribed-map-types btn-xs" (click)="getMap(sub.slug, sub.map_id, sub.map_name)">{{
            sub.map_name }}</a>
        </div>
        <div class="div_edit" *ngIf="isEdit">
          <div class="div_change">
            <div *ngIf="sub.status !== 'canceled' && sub.status !== 'expired'" class="p2 pv" id="pv">
              Cancel
            </div>
            <input *ngIf="sub.status !== 'canceled' && sub.status !== 'expired'"
              (change)="onCheckboxChange($event, sub.map_name)" type="checkbox" value="{{ sub.map_id }}"
              class="subscription-remove" />
          </div>
        </div>
        <div class="plan">
          <p class="plan_p">{{ sub.subscription }}</p>
        </div>
        <div></div>
      </div>
      <!-- wildfire damage viewer  currently removed as per client requirement-->
      <!-- <div *ngIf="sub.map_type === 'fdp-map' && sub.status !== 'expired'">
        <div class="sub_name">
          <a
            class="btn fdp-map-cls subscribed-map-types btn-xs"
            (click)="getMap(sub.slug, sub.map_id, sub.map_name)"
            >{{ sub.map_name }}</a
          >
        </div>
        <div class="div_edit" *ngIf="isEdit">
          <div class="div_change">
            <div
              *ngIf="sub.status !== 'canceled' && sub.status !== 'expired'"
              class="p2 fdp"
            >
              Cancel
            </div>
            <input
              *ngIf="sub.status !== 'canceled' && sub.status !== 'expired'"
              (change)="onCheckboxChange($event, sub.map_name)"
              type="checkbox"
              value="{{ sub.map_id }}"
              class="subscription-remove"
            />
          </div>
        </div>
        <div class="plan">
          <p class="plan_p">{{ sub.subscription }}</p>
        </div>
        <div></div>
      </div> -->
    </div>
    <div class="btn_div">
      <div class="edit_sub" *ngIf="isEdit">
        <button type="button " id="cancel-payment" (click)="back()" class="btn gernal-btn">
          Back
        </button>
        <button type="button " class="btn gernal-btn" (click)="unSubscribe($event)">
          Submit
        </button>
      </div>
    </div>
    <div id="cancel-sub-plan" *ngIf="showUnsubMessage === true">
      <p>*Access continues through end of billing cycle</p>
    </div>
  </div>
  <!-- Maps shared with me-->
  <div class="div-window_maps" id="test_shared_maps" *ngIf="isLoaded && sharedMaps.length">
    <div class="h3" style="margin-top: 0px !important">Maps Shared With Me</div>
    <div>
      <div *ngFor="let maps of sharedMaps">
        <a [ngStyle]="{'background-color': maps.map_type_color}"
          class="shared_map_name btn pv-map-cls subscribed-map-types btn-xs sharedCheck"
          (click)="getSharedMap(maps.slug, maps.map_id, maps.name, maps.col_id)">{{ maps.name }}</a>
        <!-- Wildfire damage viewer remove as per client requirement -->
        <!-- <a
          *ngIf="maps.map_type === 'fdp-map'"
          class="
            shared_map_name
            btn
            fdp-map-cls
            subscribed-map-types
            btn-xs
            sharedCheck
          "
          (click)="getSharedMap(maps.slug, maps.map_id, maps.name, maps.col_id)"
          >{{ maps.name }}</a
        > -->
        <!-- Check added to prevent showing email for wildfire damage viewer map -->
        <p class="invited_by" *ngIf="maps.map_type !== 'fdp-map'">
          Invited by {{ maps.ending_or_email }}
        </p>
        <div></div>
      </div>
    </div>
  </div>
  <!-- Direct login setting-->
  <div class="directly-login-settings" *ngIf="
      (isLoaded && subscriptionsArray.length && activeMapAvailable) ||
      (isLoaded && sharedMaps.length)
    "
  >
    <h3
      style="
        font-size: 32px !important;
        line-height: 44.8px;
        font-weight: 300;
        font-family: Arial, Helvetica, sans-serif;
      "
    >
      Preferences
    </h3>
    <p>
      <span class="span"><span class="inner_span">
          <strong class="strong">Login directly to the map last used:&nbsp;</strong>
          &nbsp; &nbsp; &nbsp;&nbsp;
          <!-- <br /> -->
          <input name="direct_login " type="radio" [value]="true" [checked]="yes" (change)="onChange($event)" />
        </span></span>
      <span class="yes">Yes&nbsp; &nbsp; &nbsp;
        <input name="direct_login " type="radio" [value]="false" [checked]="no" (change)="onChange($event)" />
        <span class="no"> &nbsp; No</span>
      </span>
    </p>
    <p *ngIf="value === 'false'" class="direct_p">
      <span class="direct_feedback directLoginText">
        <i class="directLoginText">Upon login, you will see your map list in the Dashboard.</i></span>
    </p>
    <p *ngIf="value === 'true'" class="direct_p">
      <span class="direct_feedback">
        <i class="directLoginText">Upon login, you will be taken directly to your map instead of the
          Dashboard.</i>
      </span>
    </p>
    <!-- <p>
      <span class="span">
        <span class="inner_span">
          <strong class="strong">Data Panel Font Size &nbsp;</strong>
        </span>
        <select [ngModel]="selectFontSize" (ngModelChange)="onChangeFont($event)">
          <option [value]="i.size" *ngFor="let i of fontSize">{{i.size}}</option>

        </select>
      </span>
    </p> -->
  </div>
</div>

<!-- Subscribe button if not map subscribe-->
<div
  id="become-sub"
  class="dashboard-map-text"
  *ngIf="
    (subscriptionsArray?.length === 0 && isLoaded) ||
    (!activeMapAvailable && isLoaded)
  "
>
  <div class="dropdown">
    <a class="list-deco menu-button-subscribe">Become a subscriber</a>
    <div class="dropdown-content">
      <a id="map-product-text ">Which MapPort product?</a>
      <a href="/parcelviewer/subscribe/ ">Parcel Viewer</a>
      <a href="/wildfireviewer/subscribe/ ">Wildfire Viewer</a>
      <!-- <a href="wildfiredamageviewer/subscribe/ ">Wildfire Damage Viewer</a> -->
    </div>
  </div>
</div>
